import { createWidget } from "./widget";

(function narratenowInit() {
  // Find our own <script> tag by the data-site attribute.
  const scripts =
    document.querySelectorAll<HTMLScriptElement>("script[data-site]");
  const scriptTag = Array.from(scripts).find(
    (s) => s.src.includes("narratenow") || s.dataset.site,
  );

  if (!scriptTag) {
    console.warn("[NarrateNow] No <script> tag with data-site attribute found.");
    return;
  }

  const siteId = scriptTag.dataset.site;
  if (!siteId) {
    console.warn("[NarrateNow] data-site attribute is empty.");
    return;
  }

  const apiUrl =
    scriptTag.dataset.api ?? "https://api.narratenow.app";

  // Host-supplied presentation options. These are available synchronously, so
  // the widget can paint its final appearance on the first frame instead of
  // waiting for the site config request to come back.
  //
  // They outrank the stored record, which is why the dashboard's snippet carries only
  // data-site: they are for hand-written snippets and unconnected WordPress installs
  // that keep their settings in their own markup. `mode`/`target`/`anchor` say where
  // the player goes, so the widget need not wait for the config to know where to mount.
  const options = {
    title: scriptTag.dataset.title,
    accent: scriptTag.dataset.accent,
    mode: scriptTag.dataset.mode,
    target: scriptTag.dataset.target,
    anchor: scriptTag.dataset.anchor,
    design: scriptTag.dataset.design,
    theme: scriptTag.dataset.theme,
  };

  if (!apiUrl) {
    console.warn("[NarrateNow] Could not determine API URL.");
    return;
  }

  // Wait until after React hydration before mounting.
  // DOMContentLoaded fires when HTML is parsed but React hydrates AFTER that
  // (when React's own scripts execute). window.load fires after all scripts
  // have run, so hydration is guaranteed complete by then.
  if (document.readyState === "complete") {
    createWidget(siteId, apiUrl, options);
  } else {
    window.addEventListener("load", () => createWidget(siteId, apiUrl, options), {
      once: true,
    });
  }
})();
